import { useMemo, useState } from "react";
import { useMutation, useQuery, useQueryClient } from "react-query";

import { getMetricsFacebook } from "../../../services/metricsFacebook";
import { getUpdatedCampaignsFaceInsta } from "../../../services/metricsGeneral";

import { CardDashboard } from "../CardDashboard";
import { CardGraph } from "../CardGraph";
import { Header } from "../Header";

import { Box, Grid, LinearProgress, Stack, Typography } from "@mui/material";
import { useStyles } from "../styles";

export function Facebook() {
  const styles = useStyles();
  const queryClient = useQueryClient();
  const [facebookReach, setFacebookReach] = useState([{}]);
  const [facebookImpressions, setFacebookImpressions] = useState([{}]);
  const [facebookEngagement, setFacebookEngagement] = useState([{}]);
  const [facebookReactions, setFacebookReactions] = useState([{}]);
  const [facebookComments, setFacebookComments] = useState([{}]);

  const { data, isLoading } = useQuery(
    "getMetricsFacebook",
    getMetricsFacebook
  );

  const updatedCampaignsFaceInsta = useMutation(getUpdatedCampaignsFaceInsta, {
    onSuccess: () => {
      queryClient.invalidateQueries("getMetricsFacebook");
    },
    onError: () => {
      console.log(
        "Erro ao atualizar as campanhas !!!",
        updatedCampaignsFaceInsta.error
      );
    },
  });
  //counters
  const reach = useMemo(() => ( data?.metrics?.reach ?? 0 ), [data]);
  const impressions = useMemo(() => ( data?.metrics?.impressions ?? 0 ), [data]);
  const engaged = useMemo(() => ( data?.metrics?.engaged ?? 0 ), [data]);
  const reactions = useMemo(() => ( data?.metrics?.reactions ?? 0 ), [data]);
  /*const comments = useMemo(() => ( data?.metrics?.comments ?? 0 ), [data]);*/

  // Data Graphs---------------------------------------------------
  useMemo(() => {
    setFacebookReach([{
      name: 'Alcance',
      data: data?.metrics?.metricsInMonth?.map((value: any) => ({
        x: value.date.toUpperCase(),
        y: value.reach,
      })) 
    }]);
    setFacebookImpressions([{
      name: 'Impressões',
      data: data?.metrics?.metricsInMonth?.map((value: any) => ({
        x: value.date.toUpperCase(),
        y: value.impressions,
      }))
    }]);
    setFacebookEngagement([{
      name: 'Engajamento',
      data: data?.metrics?.metricsInMonth?.map((value: any) => ({
        x: value.date.toUpperCase(),
        y: value.engaged,
      }))
    }]);
    setFacebookReactions([{
      name: 'Reações',
      data: data?.metrics?.metricsInMonth?.map((value: any) => ({
        x: value.date.toUpperCase(),
        y: value.reactions,
      })),
    }]);
    setFacebookComments([{
      name: 'Comentários',
      data: data?.metrics?.metricsInMonth?.map((value: any) => ({
      x: value.date.toUpperCase(),
      y: value.comments,
      }))
    }]);
  }, [data]);

  if ( isLoading ) {
    return (
      <Stack
        spacing={2}
        justifyContent="center"
        alignItems="center"
        width="100%"
        height="62vh"
      >
        <Typography variant="subtitle1">Buscando informações</Typography>
        <LinearProgress variant="indeterminate" sx={{ width: "50%" }} />
      </Stack>
    );
  }

  return (
    <Stack spacing={2} overflow="overlay" height="62vh">
      <Box className={styles.root}>
        <Header
          title="Facebook"
          subTitle="Veja os resultados das publicações no facebook."
          showButtonUpdate={false}
          isLoading={updatedCampaignsFaceInsta.isLoading}
          buttonClick={() => {
            updatedCampaignsFaceInsta.mutate();
          }}
        />

        <Stack>
          <Grid
            container
            display="flex"
            p="24px 24px 0 0"
            spacing={2}
            flexWrap="wrap"
          >
            <Grid item md={5.5} lg={3} width="100%">
              <CardDashboard
                insights={reach}
                title={"Alcance"}
                text={
                  "O número de pessoas únicas que foram atingidas por suas publicações no Facebook."
                }
              />
            </Grid>
            <Grid item md={5.5} lg={3} width="100%">
              <CardDashboard
                insights={impressions}
                title={"Impressões"}
                text={
                  "O número de vezes que as suas publicações entraram na tela de uma pessoa, uma pessoa pode ter visto mais de uma vez."
                }
              />
            </Grid>
            <Grid item md={5.5} lg={3} width="100%">
              <CardDashboard
                insights={engaged}
                title={"Engajamento"}
                text={
                  "O número de pessoas únicas que se envolveram de determinadas maneiras com as suas publicações, por exemplo, comentando, reagindo, compartilhando ou clicando em determinados elementos da publicação."
                }
              />
            </Grid>
            <Grid item md={5.5} lg={3} width="100%">
              <CardDashboard
                insights={reactions}
                title={"Reações"}
                text={
                  "O número de reações que você teve nas suas publicações do Facebook."
                }
              />
            </Grid>
          </Grid>
          <Stack flexDirection="column" p="24px 0" gap={3}>
            <Header />
            <Grid
              container
              display="flex"
              p="0 24px 0 0"
              spacing={4}
              flexWrap="wrap"
            >
              <Grid item md={12} lg={6} width="100%">
                <CardGraph 
                  title="Alcance"
                  text={'Alcance por mês'}
                  data_type={"REACH"}
                  data={facebookReach} 
                />
              </Grid>
              <Grid item md={12} lg={6} width="100%">
                <CardGraph 
                  title="Impressões"
                  text={'Impressões por mês'}
                  data_type="IMPRESSIONS" 
                  data={facebookImpressions} 
                />
              </Grid>
              <Grid item md={12} lg={6} width="100%">
                <CardGraph 
                  title="Engajamento"
                  text={'Engajamentos por mês'}
                  data_type="ENGAGEMENT"
                  data={facebookEngagement}
                />
              </Grid>
              <Grid item md={12} lg={6} width="100%">
                <CardGraph 
                  title="Reações"
                  text={'Reações por mês'}
                  data_type="REACTIONS"
                  data={facebookReactions} 
                />
              </Grid>
              <Grid item md={12} lg={6} width="100%">
                <CardGraph 
                  title="Comentários" 
                  text={'Comentários por mês'}
                  data_type="COMMENTS"
                  data={facebookComments} 
                />
              </Grid>
            </Grid>
          </Stack>
        </Stack>
      </Box>
    </Stack>
  );
}
